export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-gradient-to-b from-background-800 to-background-900 text-foreground-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="font-heading text-xl font-bold text-white mb-3 block cursor-pointer">
              黑料吃瓜
            </a>
            <p className="text-sm text-foreground-400 leading-relaxed">
              提供51黑料吃瓜、91黑料吃瓜、17黑料吃瓜等数字版专属入口与线路选择，
              方便用户访问不同版本。致力于打造最便捷的热门爆料内容聚合平台。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="block text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">热度榜单</a>
              <a href="#updates" onClick={(e) => handleNavClick(e, '#updates')} className="block text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">最新动态</a>
              <a href="#cards" onClick={(e) => handleNavClick(e, '#cards')} className="block text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">精选爆料</a>
              <a href="#carousel" onClick={(e) => handleNavClick(e, '#carousel')} className="block text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">焦点专题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">线路选择</h4>
            <div className="space-y-2.5">
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="block text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">51黑料吃瓜</a>
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="block text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">91黑料吃瓜</a>
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="block text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">17黑料吃瓜</a>
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="block text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">全部线路</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            黑料吃瓜 &copy; {new Date().getFullYear()} 版权所有。本站为内容聚合平台，仅为用户提供便捷的线路选择与信息导航服务。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="hover:text-white transition-colors cursor-pointer">常见问答</a>
            <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="hover:text-white transition-colors cursor-pointer">联系我们</a>
            <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="hover:text-white transition-colors cursor-pointer">关于我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}